export const OnboardingPanel = {
  flow: 'y',
  gap: 'Z1',
  CaptionTitle: {
    Text: {
      text: '{{ learn.checklist.title | polyglot }}'
    }
  },
  Flex: {
    flow: 'y',
    gap: 'Z2',
    childExtends: ['Flex', {}],
    childProps: {
      fontWeight: '400',
      isActive: false,
      isCurrent: false,
      gap: 'Z',
      align: 'center',
      ':hover': {
        textDecoration: 'underline'
      },
      Circle: {
        order: '-1',
        boxSize: 'A',
        // Was a bare `--color-line` custom-property name with no var()
        // wrapper — an invalid border shorthand value that rendered with no
        // colour. Fixed to the real token.
        border: 'hairline solid line',
        Icon: {
          name: 'checkmark'
        }
      },
      Text: {
        '.isDone': {
          fontWeight: '200',
          color: 'paragraph',
          textDecoration: 'line-through'
        }
      }
    },
    childrenAs: 'props',
    children: () => [
      {
        Text: {
          text: '{{ learn.checklist.createComponent | polyglot }}'
        },

        isDone: (el) => Object.keys(el.getSchema('components') || {}).length > 0,

        onClick: async (ev, el) => {
          ev.stopPropagation()
          await el.call('openRouterModal', '/add-component')
        }
      },

      {
        Text: {
          text: '{{ learn.checklist.reuseComponent | polyglot }}'
        },

        isDone: (el) => Object.keys(el.getSchema('components') || {}).length > 1,

        onClick: async (ev, el) => {
          ev.stopPropagation()
          const componentFound = Object.values(el.getSchema('components'))[0]
          if (!componentFound?.key) {
            return el.call('openNotification', {
              title: el.call('polyglot', 'learn.checklist.noComponent.title'),
              message: el.call('polyglot', 'learn.checklist.noComponent.message'),
              type: 'transparentPattern'
            })
          }
          await el.call('openRouterModal', '/add-component', {
            key: componentFound.key + 'Reused',
            title: (componentFound.title || componentFound.key) + ' Reused',
            type: 'components',
            value: {
              [componentFound.key]: {}
            },
            code: `export default {\n  // Reusable component:\n  ${componentFound.key}: {\n    // Overwrite properties... \n  },\n}`,
            advanced: true
          })
        }
      },

      {
        Text: {
          text: '{{ learn.checklist.createPage | polyglot }}'
        },

        isDone: (el) => (el.getSchema('pages') || {})['/'],

        onClick: async (ev, el) => {
          ev.stopPropagation()
          await el.call('openRouterModal', '/add-page', {
            title: 'Main page',
            key: '/',
            type: 'pages',
            value: {
              '/': {
                H1: {
                  text: 'Hello Symbols'
                }
              }
            },
            code: `export default {\n  '/': {\n    H1: { text: 'Hello Symbols' } \n  },\n}`,
            advanced: true
          })
        }
      },

      {
        Text: {
          text: '{{ learn.checklist.openPage | polyglot }}'
        },

        isDone: (el) => el.call('getCookie', el.getAppKey() + '_projectRemotePageWasViewed'),

        onClick: (ev, el) => {
          ev.stopPropagation()
          const pageFound = Object.values(el.getSchema('pages'))[0]
          if (!pageFound?.key) {
            return el.call('openNotification', {
              title: el.call('polyglot', 'learn.checklist.noPage.title'),
              message: el.call('polyglot', 'learn.checklist.noPage.message'),
              type: 'transparentPattern'
            })
          }

          const url = `https://${el.getAppKey()}/${pageFound.key}`
          window.open(url, 'Symbols preview')

          el.call('setCookie', el.getAppKey() + '_projectRemotePageWasViewed', true)
        }
      },

      {
        Text: {
          text: '{{ learn.checklist.importLibrary | polyglot }}'
        },

        // add flag to confirm component was added,
        isDone: (el) => Object.keys(el.getSchema('components')).length > 1,

        onClick: (ev, el) => {
          ev.stopPropagation()
          el.setWindow('explorer', 'insert:library')
        }
      },

      {
        Text: {
          text: '{{ learn.checklist.uploadLogo | polyglot }}'
        },

        isDone: (el) => Object.keys(el.getData('files')).length > 0,

        onClick: async (ev, el) => {
          ev.stopPropagation()
          await el.call('openRouterModal', '/add-file')
        }
      },

      {
        Text: {
          text: '{{ learn.checklist.addColor | polyglot }}'
        },

        isDone: (el) => Object.keys(el.getData('designSystem').color || {}).length > 2,

        onClick: (ev, el) => {
          ev.stopPropagation()
          el.call('activeAddingFloatingPanel', ev, 'color')
        }
      },

      // {
      //   Text: {
      //     text: 'Setup a global theme'
      //   },

      //   isDone: el =>
      //     Boolean(
      //       el.getData('designSystem').theme?.document[
      //         '@' + el.call('getSystemGlobalTheme')
      //       ]
      //     ),

      //   onClick: (ev, el) => {
      //     ev.stopPropagation()
      //     el.call('activeAddingFloatingPanel', ev, 'global_theme')
      //   }
      // }

      {
        Text: {
          text: '{{ learn.checklist.publish | polyglot }}'
        },

        isDone: (el) => el.call('getCookie', el.getAppKey() + '_projectWasPublished'),

        onClick: async (ev, el) => {
          ev.stopPropagation()
          await el.call('openRouterModal', '/publish')
        }
      }
    ]
  }
}
